import imageProperties from '../lib/image-properties'

const createQuery = () => `
  ... on CompanyGallery {
    galleryImages {
      image_768 {
        ${imageProperties}
      }
    }
  }
`

export default createQuery
